import styled from "styled-components";

const StyledHeaderLanguage = styled.div`
  & .lang {
    display: flex;
    margin: 0 auto;
    height: 40px;
    width: fit-content;
    position: relative;
    z-index: 10px;
    &__text {
      display: flex;
      align-items: center;
      margin-right: 10px;
      font-weight: 400;
      font-size: 10px;
      line-height: 12px;
      color: #b8b8b8;
    }
  }
`;
export default StyledHeaderLanguage;
